type Method = "GET" | "POST" | "DELETE" | "PUT" | "PATCH"

export const Fetch = async (url: string, method: Method, body: Object, params = {}) => {
  const headers = new Headers()
  headers.set('Accept', 'application/json');
  headers.set('Content-Type', 'application/json');
  headers.set('X-Requested-With', 'XMLHttpRequest');

  const res = await fetch(url, {
    method: method,
    headers,
    body: method !== "GET" ? JSON.stringify(body) : null,
    ...params
  })

  return res
}